module.exports = __webpack_public_path__ + "static/blueprint2-optimised-9852a7fcc8111b9edba9849abc0aa925.jpg";